import { isEmpty } from 'lodash';
import { RichText as PrismicRichText } from 'prismic-reactjs';
import React from 'react';

import { linkResolver } from 'utils/linkResolver';
import { Link } from 'components/link/Link';

import { IPrismicRichText } from 'types/prismicRichtext';

import s from './RichText.scss';

interface IProps {
  children: any;
}

const link = (
  type: any,
  element: any,
  content: any,
  children: any,
  index: any
) => {
  const target = element.data && element.data.target;

  const key = element.data.id || index;

  if (element.data && element.data.url) {
    return (
      <a key={key} href={linkResolver(element.data)} target={target}>
        {children}
      </a>
    );
  }

  return (
    <Link key={key} to={linkResolver(element.data)} target={target}>
      {children}
    </Link>
  );
};

export function asText(value?: IPrismicRichText | null | undefined): string {
  // just in case someone sends us a string
  if (typeof value === 'string') {
    return value;
  }

  return PrismicRichText.asText(value || []);
}

export const RichText = ({ children }: IProps) => {
  if (isEmpty(children)) {
    return null;
  }

  return (
    <div className={s.richText}>
      <PrismicRichText render={children} serializeHyperlink={link} />
    </div>
  );
};
